import React from 'react'
import SignIn from '../../components/auth/SignIn'
import { useFormik } from 'formik';
import { useState } from 'react';
import * as yup from 'yup';
import { signInUserApi } from '../../api/auth.api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signInSuccess, signInError } from '../../redux/auth.slice'
import swal from 'sweetalert';
import { offLoading } from '../../redux/loading.slice';

const SignInContainer = () => {

  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      username: '',
      password: ''
    },
    // validationSchema: yup.object().shape({
    //   username: yup.string().required('Required'),
    //   password: yup.string().required('Required')
    // }),
    onSubmit: values => {
      signInUserApi(values, dispatch)
        .then(res => {
          if (!res.data.token) {
            const warning = "Your account is not active. Please check your email to activate account!"
            dispatch(offLoading());
            swal({
              title: "Warning!",
              text: warning,
              icon: "warning",
              buttons: "OK",
              // timer: 3000,
            });
          } else {
            localStorage.setItem("userLoggedIn", JSON.stringify(res.data));
            dispatch(signInSuccess(res.data));
            dispatch(offLoading());
            navigate("/");
          }
        })
        .catch((err) => {
          console.log(err);
          dispatch(offLoading());
          dispatch(signInError("Username or password invalid. Please try again!"));
        });
    }
  })

  return (
    <SignIn
      formik={formik}
      setShowPassword={setShowPassword}
      showPassword={showPassword}
    />
  )
}

export default SignInContainer